module.exports = __webpack_public_path__ + "static/app-store-dark-363e0eadb8db05cb67b7aad876d288ab.svg";